// extracted by mini-css-extract-plugin
export default {"backdrop":"PokemonDetailsBackdrop_backdrop__MNnuH"};